module.exports = __webpack_public_path__ + "assets/img/247901.400eb9c3.png";